'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    GET_SCREEN_DATA_EDITCONFIGURACION_STARTS,
    SET_USER_FUNCTIONS_EDITCONFIGURACION,
    GET_SCREEN_DATA_EDITCONFIGURACION_SUCCESS,
    RESET_STATE_EDITCONFIGURACION,
    DO_TRANSACTION_EDITAR_CONFIGURACION_SUCCESS,
    DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED,
    DO_TRANSACTION_EDITAR_CONFIGURACION_START,
    CHECKBOX_VALUE_CHANGE_CONFIG_SESION_EDIT,
    CONFIGURATION_TYPE_CHANGE,
    RADIO_BUTTON_CHANGE_CONF_SESION_EDIT,
    TEXT_CHANGE_CONF_SESION_EDIT,
    PLATAFORMA_VALUE_CHANGE_CONF_SESION_EDIT,
    RADIO_CONTRASENIA_CHANGE_CONF_SESION_EDIT,
    ESCONDER_POPUP_EDITCONFIGURACION,
    REDIRECT_OK_CONFIGURACION
} from '../../Screens/ConfiguracionSesionEditar/actions/ConfiguracionSesionEditar';

const initialState = {
    isFetching: false,
    tipoConfiguracion: 1,
    functions: [],
    plataformas: [],
    redirect: false,

    idConfiguracionPasswordSesion: null,
    alfabetica: false,
    cantIntentosFallidos: null,
    cantidadRepeticiones: null,
    caracteresMinimos: null,
    caracteresEspeciales: false,
    caseSensitive: false,
    maxDiasCaducidad: null,
    maxDiasInactividad: null,
    minutosPermitidosInactividad: null,
    numerica: false,
    permiteCaracteresIguales: false,
    permiteLetrasConsecutivas: false,
    permiteNrosConsecutivos: false,
    permiteRepetirPosicion: false,

    vincularGrupoWindows: false,
    altaAutomatica: false,
    soloUsuarioLoggeado: false,
    solicitarContrasenia: false,

    //Error
    message: "",
    messageClass: "",
    messageHidden: true
};

let result;


/**
 * 
 * @param {any} state
 * @param {any} action
 */
function configuracionSesionEditar(state = initialState, action) {
    switch (action.type) {
        /*CARGA INICIAL*/
        case GET_SCREEN_DATA_EDITCONFIGURACION_STARTS:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                isFetching: true
            };
            break;

        /*SETEO DE FUNCIONES*/
        case SET_USER_FUNCTIONS_EDITCONFIGURACION:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        /*DATOS DE BD*/
        case GET_SCREEN_DATA_EDITCONFIGURACION_SUCCESS:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let maxDiasInactividad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MaxDiasInactividad;
            let minutosPermitidosInactividad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MinutosPermitidosInactividad;
            let cantIntentosFallidos = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CantIntentosFallidos;
            let cantidadRepeticiones = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CantidadRepeticiones;
            let caracteresMinimos = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaracteresMinimos;
            let maxDiasCaducidad = action.result.GET_CONFIGURATION_PASSWORD_SESION[0].MaxDiasCaducidad;
            let tipoSeguridad = action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].TipoSeguridad;
            sessionStorage.setItem('PantallaCambios', false);


            result = {
                ...state,
                idConfiguracionPasswordSesion: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].Id,
                caracteresEspeciales: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaracteresEspeciales,
                alfabetica: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].Alfabetica,
                cantIntentosFallidos: cantIntentosFallidos == 0 ? null : cantIntentosFallidos,
                cantidadRepeticiones: cantidadRepeticiones == 0 ? null : cantidadRepeticiones,
                caracteresMinimos: caracteresMinimos == 0 ? null : caracteresMinimos,
                caseSensitive: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].CaseSensitive,
                maxDiasCaducidad: maxDiasCaducidad == 0 ? null : maxDiasCaducidad,
                maxDiasInactividad: maxDiasInactividad == 0 ? null : maxDiasInactividad,
                minutosPermitidosInactividad: minutosPermitidosInactividad == 0 ? null : minutosPermitidosInactividad,
                numerica: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].Numerica,
                permiteCaracteresIguales: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteCaracteresIguales,
                permiteLetrasConsecutivas: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteLetrasConsecutivas,
                permiteNrosConsecutivos: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteNrosConsecutivos,
                permiteRepetirPosicion: action.result.GET_CONFIGURATION_PASSWORD_SESION[0].PermiteRepetirPosicion,
                plataformas: action.result.GET_TIPO_PLATAFORMA,

                idConfPasswordType: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].ID_CONF_PASSWORD_TYPE,
                vincularGrupoWindows: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].VincularGrupoWindows,
                altaAutomatica: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].AltaAutomatica,
                soloUsuarioLoggeado: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].SoloUsuarioLoggeado,
                solicitarContrasenia: action.result.GET_CONFIGURATION_PASSWORD_TYPE[0].SolicitarContrasenia,
                tipoConfiguracion: tipoSeguridad == "GYF" ? 1 : 2,

                maxDiasInactividadCheck: (maxDiasInactividad && maxDiasInactividad != null) ? true : false,
                minutosPermitidosInactividadCheck: (minutosPermitidosInactividad && minutosPermitidosInactividad != null) ? true : false,

                isFetching: false,
                redirect: false
            };
            break;

        case RESET_STATE_EDITCONFIGURACION:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = initialState;
            break;

        case REDIRECT_OK_CONFIGURACION:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                isFetching: false,
                redirect: true
            };
            break;

        case CONFIGURATION_TYPE_CHANGE:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let temp;

            if (action.oldConf == 1)
                temp = 2;
            else
                temp = 1;

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                //Hardocdeo valores por default
                ...state,
                alfabetica: false,
                cantIntentosFallidos: 3,
                cantidadRepeticiones: null,
                caracteresEspeciales: false,
                caracteresMinimos: 5,
                caseSensitive: false,
                maxDiasCaducidad: 30,
                maxDiasInactividad: 60,
                minutosPermitidosInactividad: 15,
                numerica: false,
                permiteCaracteresIguales: false,
                permiteLetrasConsecutivas: false,
                permiteNrosConsecutivos: false,
                permiteRepetirPosicion: false,

                vincularGrupoWindows: false,
                altaAutomatica: false,
                soloUsuarioLoggeado: false,
                solicitarContrasenia: false,

                redirect: false
            };

            result.plataformas.forEach(function (element) {
                element.CanLog = 0;
            });

            result.tipoConfiguracion = temp;

            break;

        case RADIO_BUTTON_CHANGE_CONF_SESION_EDIT:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let estadoRadio = JSON.parse(JSON.stringify(state));

            estadoRadio[action.obj.identifier] = action.obj.boolean;


            estadoRadio["solicitarContrasenia"] = false;

            sessionStorage.setItem('PantallaCambios', true);

            result = estadoRadio;

            break;

        case RADIO_CONTRASENIA_CHANGE_CONF_SESION_EDIT:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let estadoRadioContrasenia = JSON.parse(JSON.stringify(state));
            estadoRadioContrasenia[action.obj.identifier] = action.obj.boolean;
            sessionStorage.setItem('PantallaCambios', true);
            result = estadoRadioContrasenia;

            break;

        case CHECKBOX_VALUE_CHANGE_CONFIG_SESION_EDIT:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let estado = JSON.parse(JSON.stringify(state));

            if (action.obj.identifier != "solicitarContrasenia" || (action.obj.identifier == "solicitarContrasenia" && estado["soloUsuarioLoggeado"] == true)) {

                if (typeof estado[action.obj.identifier] == 'boolean')
                    estado[action.obj.identifier] = !estado[action.obj.identifier];
                else {
                    if (!action.obj.checked)
                        estado[action.obj.identifier] = null;
                    else
                        estado[action.obj.identifier] = 0;
                }

                if (action.obj.identifier == "vincularGrupoWindows" && estado["vincularGrupoWindows"] == false) {
                    estado["altaAutomatica"] = false;
                } else if (action.obj.identifier == "permiteCaracteresIguales" && action.obj.checked == false) {
                    estado["permiteLetrasConsecutivas"] = false;
                    estado["permiteCaracteresIguales"] = false;
                    estado["permiteNrosConsecutivos"] = false;
                }

            } else {
                estado[action.obj.identifier] = false;
            }
            sessionStorage.setItem('PantallaCambios', true);

            result = estado;

            break;

        case PLATAFORMA_VALUE_CHANGE_CONF_SESION_EDIT:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let estadoPlataforma = JSON.parse(JSON.stringify(state));

            estadoPlataforma.plataformas.forEach(function (element) {
                if (element.Descripcion == action.obj.descripcion)
                    element.CanLog = action.obj.value;
            });
            sessionStorage.setItem('PantallaCambios', true);

            result = estadoPlataforma;

            break;

        case TEXT_CHANGE_CONF_SESION_EDIT:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            let estadoText = JSON.parse(JSON.stringify(state));

            estadoText[action.obj.identifier] = action.obj.value;
            sessionStorage.setItem('PantallaCambios', true);
            result = estadoText;

            break;

        case DO_TRANSACTION_EDITAR_CONFIGURACION_START:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                isFetching: true,
                message: "",
                messageClass: "",
                messageHidden: true,
                redirect: false
            };
            break;

        case DO_TRANSACTION_EDITAR_CONFIGURACION_SUCCESS:

            result = {
                ...state,
                isFetching: false,
                message: "",
                messageClass: "",
                messageHidden: true,
                redirect: true
            };

            break;

        case DO_TRANSACTION_EDITAR_CONFIGURACION_FAILED:

            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                isFetching: false,
                message: action.saveErrorMessage,
                messageClass: "error",
                messageHidden: false,
                redirect: false
            };

            break;

        case ESCONDER_POPUP_EDITCONFIGURACION:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true,
                redirect: false
            };

            break;

        default:
            LogHelper.In(configuracionSesionEditar.name, action, state);

            result = { ...state };
            break;
    }

    LogHelper.Out(configuracionSesionEditar.name, result);
    return result;
}

export default configuracionSesionEditar;